function ClientAddForm($rootDom) {
    var form = new ClientForm($rootDom);
    var popup = new ClientPopup($rootDom, {title: "ADD NEW CLIENT"});

    var m = {
        init: function() {
            form.reset();
            m.initForm();

            popup.init();
            popup.onClose(form.resetValidation);
        },

        initForm: function() {
            form.isMultiOrganization()
                ? form.disableForm()
                : form.enableForm()
        },
    };

    return m;
}
